import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from "vuex-persistedstate"
import Cookies from 'js-cookie'

// import SecureLS from "secure-ls";
// var ls = new SecureLS({ isCompression: false });

import { Ability } from '@casl/ability'

import createLogger from 'vuex/dist/logger'

import alert from './modules/alert'
import auth from './modules/auth'
import image from './modules/image'
import message from './modules/message'
import password from './modules/password'
import signup from './modules/signup'
import user from './modules/user'

Vue.use(Vuex)

// const vuexLocalStorage = new VuexPersistence({
//   key: 'vuex',
//   storage: window.localStorage
// })

export default new Vuex.Store({

  modules: {
    alert,
    auth,
    image,
    message,
    password,
    signup,
    user,
  },

  getters: {

    ability() {

      return new Ability([], {
        subjectName(subject) {
          return subject

        }
      })
    }

  },

  plugins: [
    createPersistedState({
      paths: ['auth', 'user'],
      storage: {
        getItem: key => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: false }),
        removeItem: key => Cookies.remove(key)
      },
    }),
    createPersistedState({
      paths: ['image'],
      // storage: {
      //   getItem: (key) => ls.get(key),
      //   setItem: (key, value) => ls.set(key, value),
      //   removeItem: (key) => ls.remove(key),
      // },
    }),
    createLogger()
  ]

})
